import * as types from '../constants';
import _ from 'lodash';
import axios from 'axios';

export const setGlobalVariable = body => dispatch => {
  dispatch({
      type: types.SET_GLOBAL_VARIABLE,
      payload: body,
  })
}
